module.exports = __webpack_public_path__ + "img/card-why-not.2f71fa3f.jpg";